import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { DPRestrictedPage } from "Components/DP";
import { PageNotFound } from "..";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { PresettlementExclusionTable } from "./PresettlementExclusionsTable/PresettlementExclusionsTable";
import { PresettlemetExclusionActions } from "./PresettlemetExclusionActions/PresettlemetExclusionActions";
import useStyles from "./styles";

export const PresettlementExclusionsReport = () => {
  const { enabledFeatures, permissions } = usePartnerConfig();
  const classes = useStyles();

  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.PaydayExclusionsReportingPageViewed,
    });
  };

  const hidePage =
    enabledFeatures.indexOf("provider_presettlement_exclusions_reports") === -1 ||
    !permissions.canViewPresettlementExclusionReports;

  if (hidePage) {
    return <PageNotFound />;
  }

  return (
    <DPRestrictedPage
      title="Payday Exclusions"
      onPageLoad={onPageLoad}
      permissionKey="canViewReports"
    >
      <Grid container spacing={2}>
        <HelpText>
          <b>What is the Payday Exclusions Report?</b> A list of all users whose
          remainder payment was not pre-funded for the selected pay date prior
          to payday.
        </HelpText>
        <PresettlemetExclusionActions />
        <Grid item xs={12}>
          <Typography variant="h3" className={classes.tableTitle}>
            Payday Exclusions Report
          </Typography>
          <PresettlementExclusionTable />
        </Grid>
      </Grid>
    </DPRestrictedPage>
  );
};
